import { useEffect, useState } from "react";
import { Dialog } from "@mui/material";

const MIN_REASON_CHARS = 5;

/** A thumbs down asks what didn't work, as the web app's processing checklist does (TaskFeedbackReasonModal). */
const FeedbackReasonModal = ({ open, existingReason = "", onClose, onSubmit }) => {
  const [reason, setReason] = useState(existingReason);

  useEffect(() => {
    if (open) {
      setReason(existingReason);
    }
  }, [open, existingReason]);

  const trimmed = reason.trim();
  const isReady = trimmed.length >= MIN_REASON_CHARS;
  const submit = () => isReady && onSubmit(trimmed);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        className: "aav2-reason-modal",
        sx: { width: 588, maxWidth: "calc(100% - 32px)", m: 2, borderRadius: "12px", backgroundColor: "var(--surface-raised)", backgroundImage: "none" },
      }}
    >
      <h2 className="aav2-reason-title">Tell us more</h2>
      <label className="aav2-reason-label" htmlFor="aav2-reason-input">
        What didn’t work in this answer?
      </label>
      <textarea
        id="aav2-reason-input"
        className="aav2-reason-input"
        rows={6}
        autoFocus
        value={reason}
        placeholder="Please explain what could be improved..."
        onChange={(event) => setReason(event.target.value)}
        onKeyDown={(event) => event.key === "Enter" && (event.metaKey || event.ctrlKey) && submit()}
      />
      <div className="aav2-reason-actions">
        <button type="button" className="aav2-btn ghost" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="aav2-btn primary" disabled={!isReady} onClick={submit}>
          Submit
        </button>
      </div>
    </Dialog>
  );
};

export default FeedbackReasonModal;
